import { z } from 'zod'

import type { CollegeItem } from './types'

export function emailMatchesCollege({
  email,
  college,
}: {
  email: string
  college: CollegeItem | null
}): boolean {
  if (college == null) {
    return false
  }

  const trimmedEmail = email.trim().toLowerCase()

  const validationResult = z.string().email().safeParse(trimmedEmail)

  if (!validationResult.success) {
    return false
  }

  const emailDomain = trimmedEmail.slice(trimmedEmail.indexOf('@') + 1)

  const indexOfFirstPeriod = emailDomain.indexOf('.')

  const emailDomainAfterFirstSubdomain =
    indexOfFirstPeriod === -1 ? null : emailDomain.slice(indexOfFirstPeriod + 1)

  return college.domains.some(
    domain => emailDomain === domain || emailDomainAfterFirstSubdomain === domain
  )
}
